<template>
  <c-table
    v-if="detailInfo.length"
    :data="detailInfo"
    :tableColumns="tableColumns"
  >
  </c-table>
  <div v-else>暂无申请历史！</div>
</template>

<script>
import Configs from "./data/major";
import CTable from "@/components/CTable";
export default {
  components: {
    CTable,
  },
  data() {
    let { tableColumnsHistory, tableColumns } = Configs(this);
    return {
      tableColumns: tableColumnsHistory,
    };
  },
  props: {
    detailInfo: {
      type: Array,
      default: [],
    },
  },
};
</script>
